import { API_FLAG_CASE_BOOKMARK, API_FLAG_CASE_SINGLE } from "../../config";
import httpClient from "../../httpClient";

export const flagcaseBookmarkCase = {
    bookmark: (id, data) => httpClient.post(API_FLAG_CASE_BOOKMARK + '/' + id, data),
};
export const getShowFlagCase = {
    caseInfo: (id,) => httpClient.get(API_FLAG_CASE_SINGLE + '/' + id),
};
